export const PRIVACY_NOTICE_URL =
  'https://docs.stone.com.br/aviso-de-privacidade/';
export const PRIVACY_PORTAL_URL =
  'https://docs.stone.com.br/portal-de-privacidade/';
